export default [
    {
      title: 'Dog Breed Classification',
      description: 'This project endeavors to distinguish various dog breeds through a web application employing a Convolutional Neural Network (CNN) algorithm integrated with Flask. We conducted experiments utilizing four distinct pre-trained models: Xception, Inception-V3, InceptionResNet-V2, and ResNet152-V2. Ultimately, we selected the model that offered the optimal balance of lightweight design and accuracy for deployment within the web application.',
      imageUrl: 'dogbreed.gif',
      link:'https://github.com/wwwwww0421/dog-breed-classification',
    },
    {
      title: 'Confluence AI Search Engine',
      description: 'This project transforms static Confluence documentation into an intelligent Q&A assistant that instantly answers user questions with accurate, context-aware responses using Neo4j and Llama3.',
      imageUrl: 'qa_demo.gif',
      link:'https://github.com/wwwwww0421/ConfluenceMiniProject',
    },
    {
      title: 'Real Estate Web Scraping',
      description: 'This project caters to individuals in search of houses and land in the market. The dashboard simplifies the process by providing a clear visualization of both price ranges and distribution within selected areas. This streamlined presentation facilitates quicker decision-making by enabling users to grasp crucial information more easily.',
      imageUrl: 'RealEstate.JPEG',
      link:'https://github.com/wwwwww0421/Scraping-Real-Estate-Tainan',
    },
    {
      title: 'Canada Wildfire',
      description: 'This project concluded in June 2023, coinciding with the invasion of Canada wildfires into New York, resulting in a pervasive yellow hue outdoors. In response, our focus shifted to examining indoor air quality data to assess the impact of these environmental conditions on indoor environments.',
      imageUrl: 'wildfire.JPEG',
      link:'https://www.instagram.com/reel/CtRrrKBtloR/?igsh=Y2Z3eG96d3MzNndl',
    },
    {
      title: 'Amsterdam School Study',
      description: 'This project involves the deployment of 100 air purifiers, targeting improvement in air quality across 10 primary schools. Utilising A/B testing and statistical analysis, our objective is to demonstrate the tangible benefits of air purification systems in supporting local schools to enhance the quality of the air they breathe.',
      imageUrl: 'AmsterdamSchool.JPEG',
      link:'https://www.dyson.nl/onderzoek-scholen-amsterdam',
    },
    {
      title: 'Outdoor AQ Dashboard',
      description: 'This Tableau dashboard features website navigations and presents the outdoor air quality data for the past five years across various regions. Users can select their desired country, prompting the dashboard to transition to the next page, offering more detailed information. This interactive tool allows users to delve into granular levels, down to the city level.',
      imageUrl: 'WorldAQ.JPEG',
      link:'',
    },
  ];